import { useState } from "react";
import { getStoredAccountType } from "../auth";
import { AdminSubmitInvoiceWizard } from "./AdminSubmitInvoiceWizard";

/**
 * Saisie d'une facture de prestataire : réservée à l'administration SafeCheck
 * (l'assureur transmet les factures, l'Admin les saisit pour l'assureur concerné).
 */
export function SubmitInvoicePage() {
  const [accountType] = useState(() => getStoredAccountType());

  if (accountType === "admin") {
    return <AdminSubmitInvoiceWizard />;
  }

  return (
    <div className="theme-card p-5 text-sm text-muted">
      La saisie des factures est assurée par l&apos;administration SafeCheck.
    </div>
  );
}
